import { render, staticRenderFns } from "./ScheduleOnboardingCallConfirmation.vue?vue&type=template&id=47a3b2d6&"
import script from "./ScheduleOnboardingCallConfirmation.vue?vue&type=script&lang=ts&"
export * from "./ScheduleOnboardingCallConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports